import Vue from 'vue'
import Router from 'vue-router'
import { isLoggedIn, getUser } from '../utils/auth'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue'),
      meta: { guest: true }
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('../views/Register.vue'),
      meta: { guest: true }
    },
    {
      path: '/',
      name: 'Dashboard',
      component: () => import('../views/Dashboard.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/devices',
      name: 'Devices',
      component: () => import('../views/Devices.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/devices/:id',
      name: 'DeviceDetail',
      component: () => import('../views/DeviceDetail.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/computers',
      name: 'Computers',
      component: () => import('../views/Computers.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/computers/add',
      name: 'ComputerForm',
      component: () => import('../views/ComputerForm.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/computers/:id',
      name: 'ComputerDetail',
      component: () => import('../views/ComputerDetail.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/computers/:id/edit',
      name: 'ComputerEdit',
      component: () => import('../views/ComputerForm.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/groups',
      name: 'Groups',
      component: () => import('../views/Groups.vue'),
      meta: { requiresAuth: true, admin: true }
    },
    {
      path: '/groups/:id',
      name: 'GroupDetail',
      component: () => import('../views/GroupDetail.vue'),
      meta: { requiresAuth: true, admin: true }
    },
    {
      path: '/admin/users',
      name: 'AdminUsers',
      component: () => import('../views/AdminUsers.vue'),
      meta: { requiresAuth: true, admin: true }
    },
    {
      path: '/admin/users/:id',
      name: 'AdminUserDetail',
      component: () => import('../views/AdminUserDetail.vue'),
      meta: { requiresAuth: true, admin: true }
    },
    {
      path: '/admin/devices',
      name: 'AdminDevices',
      component: () => import('../views/AdminDevices.vue'),
      meta: { requiresAuth: true, admin: true }
    },
    {
      path: '/admin/devices/:id',
      name: 'AdminDeviceDetail',
      component: () => import('../views/AdminDeviceDetail.vue'),
      meta: { requiresAuth: true, admin: true }
    },
    {
      path: '/admin/computers',
      name: 'AdminComputers',
      component: () => import('../views/AdminComputers.vue'),
      meta: { requiresAuth: true, admin: true }
    },
    {
      path: '/admin/computers/:id',
      name: 'AdminComputerDetail',
      component: () => import('../views/ComputerDetail.vue'),
      meta: { requiresAuth: true, admin: true }
    },
    {
      path: '/logs',
      name: 'Logs',
      component: () => import('../views/Logs.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/dashboard',
      name: 'AdminDashboard',
      component: () => import('../views/AdminDashboard.vue'),
      meta: { requiresAuth: true, admin: true }
    },
    {
      path: '/admin/logs',
      name: 'AdminLogs',
      component: () => import('../views/AdminLogs.vue'),
      meta: { requiresAuth: true, admin: true }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('../views/Settings.vue')
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () => import('../views/Profile.vue'),
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isLoggedIn()) {
    next('/login')
  } else if (to.meta.guest && isLoggedIn()) {
    next('/')
  } else if (to.meta.admin) {
    const user = getUser()
    if (user && user.role === 'admin') {
      next()
    } else {
      next('/')
    }
  } else {
    next()
  }
})

export default router
